import React, { Component } from "react";
//import "../login/style.scss";
import { Cookies } from "react-cookie";
import { Redirect, Link } from "react-router-dom";
import { observer } from "mobx-react";
import UserStore from "../../stores/UserStore";
import Inner from "../template/Inner";
import AppStore from "../../stores/AppStore";
import Spinner from "react-spinkit";
import Button from "@material-ui/core/Button";
import api from "../../lib/api";

import { Formik } from "formik";
import Dropzone from "react-dropzone";

import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";

@observer
class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = { agent: null, error: false, toAgents: false };
  }

  componentDidMount() {
    this.loadProfile();
  }

  loadProfile() {
    api.getProfile(
      response => {
        if (!response) {
          this.setState({ error: true });
        } else {
          if (Array.isArray(response) && !response.length) {
            this.setState({ error: true });
          } else {
            this.setState({ agent: response });
          }
        }
      },
      error => {
        this.setState({ error: true });
      }
    );
  }

  agents() {
    if (this.state.error) {
      return (
        <div className="centerBox">
          <img src="https://bk.homestack.com/assets/img/not-found.svg" />
          <h2>Unable to load data</h2>
          <p>
            <button
              onClick={() => {
                this.setState({ error: false });
                this.loadProfile();
              }}
            >
              Try again
            </button>
          </p>
        </div>
      );
    }

    if (!this.state.agent) {
      return (
        <div
          class="d-flex w-100 justify-content-center align-items-center"
          style={{ height: "100vh" }}
        >
          <div class="spinner-border text-warning" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      );
    }

    const item = this.state.agent;

    return (
      <section class="admin-content">
        <div class="bg-dark bg-dots m-b-30">
          <div class="container">
            <div class="row p-b-60 p-t-60">
              <div class="col-lg-8 text-center mx-auto text-white p-b-30">
                <div class="m-b-10">
                  <div class="avatar avatar-lg ">
                    <div class="avatar-title bg-info rounded-circle fe fe-user " />
                  </div>
                </div>
                <h3>Profile </h3>
              </div>
            </div>
          </div>
        </div>

        <div class="container pull-up">
          <div class="row">
            <div class="col-lg-6">
              <div class="card m-b-30">
                <div class="card-body ">
                  <Formik
                    initialValues={{
                      display_name: item.display_name,
                      email: item.email,
                      phone: item.phone,
                      web: item.web,
                      bio: item.bio,
                      licenseDisplay: item.license.licenseDisplay,
                      licenseNumber: item.license.licenseNumber,
                      licensePrefix: item.license.licensePrefix,
                      active: item.active
                    }}
                    validate={values => {
                      let errors = {};

                      if (!values.display_name) {
                        errors.display_name = "Required";
                      }

                      if (!values.email) {
                        errors.email = "Required";
                      } else if (
                        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
                          values.email
                        )
                      ) {
                        errors.email = "Invalid email address";
                      }
                      return errors;
                    }}
                    onSubmit={(values, { setSubmitting }) => {
                      setTimeout(() => {
                        //alert(JSON.stringify(values, null, 2));

                        api.updateProfile(
                          values,
                          response => {
                            this.forceUpdate();

                            window.showToastMessage(
                              "Success",
                              "Profile has been saved"
                            );
                          },
                          error => {
                            window.showToastMessage(
                              "Error",
                              "Error saving profile",
                              "danger",
                              "fe-x"
                            );
                          },
                          item.id
                        );

                        setSubmitting(false);
                      }, 400);
                    }}
                  >
                    {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleBlur,
                      handleSubmit,
                      isSubmitting
                      /* and other goodies */
                    }) => (
                      <form onSubmit={handleSubmit}>
                        <p>
                          <label for="display_name">Name</label>
                          <input
                            type="text"
                            class={
                              errors.display_name
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                            name="display_name"
                            id="display_name"
                            placeholder="Agent name"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.display_name}
                          />
                          <div class="invalid-feedback">
                            {errors.display_name &&
                              touched.display_name &&
                              errors.display_name}
                          </div>
                        </p>

                        <p>
                          <label for="email">Email</label>
                          <input
                            type="email"
                            class={
                              errors.email
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                            name="email"
                            id="email"
                            placeholder="Agent email"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.email}
                          />
                          <div class="invalid-feedback">
                            {errors.email && touched.email && errors.email}
                          </div>
                        </p>

                        <p>
                          <label for="phone">Phone</label>
                          <input
                            type="text"
                            class={
                              errors.phone
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                            name="phone"
                            id="phone"
                            placeholder="Agent phone"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.phone}
                          />
                          <div class="invalid-feedback">
                            {errors.phone && touched.phone && errors.phone}
                          </div>
                        </p>

                        <p>
                          <label for="web">Website</label>
                          <input
                            type="text"
                            class={
                              errors.web
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                            name="web"
                            id="web"
                            placeholder="Agent website"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.web}
                          />
                          <div class="invalid-feedback">
                            {errors.web && touched.web && errors.web}
                          </div>
                        </p>

                        <p>
                          <label for="bio">Biography</label>
                          <input
                            type="text"
                            class={
                              errors.bio
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                            name="bio"
                            id="bio"
                            placeholder="Agent bio"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.bio}
                            maxLength={200}
                          />
                          <div class="invalid-feedback">
                            {errors.bio && touched.bio && errors.bio}
                          </div>
                        </p>

                        <hr />

                        <FormGroup row>
                          <FormControlLabel
                            control={
                              <Switch
                                color="primary"
                                checked={values.licenseDisplay}
                                onChange={() => {
                                  //form.setFieldValue("email", "wwooo");
                                  values.licenseDisplay = !values.licenseDisplay;
                                  this.forceUpdate();
                                }}
                                //onChange={handleChange}
                                //value="1"
                              />
                            }
                            label="Display license details"
                          />
                        </FormGroup>

                        {values.licenseDisplay && (
                          <div>
                            <p>
                              <label for="licensePrefix">
                                License Prefix (if required)
                              </label>
                              <input
                                type="text"
                                class={
                                  errors.licensePrefix
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                                name="licensePrefix"
                                id="licensePrefix"
                                placeholder="Agent license prefix"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.licensePrefix}
                              />
                              <div class="invalid-feedback">
                                {errors.licensePrefix &&
                                  touched.licensePrefix &&
                                  errors.licensePrefix}
                              </div>
                            </p>

                            <p>
                              <label for="licenseNumber">License #</label>
                              <input
                                type="text"
                                class={
                                  errors.licenseNumber
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                                name="licenseNumber"
                                id="licenseNumber"
                                placeholder="Agent license #"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.licenseNumber}
                              />
                              <div class="invalid-feedback">
                                {errors.licenseNumber &&
                                  touched.licenseNumber &&
                                  errors.licenseNumber}
                              </div>
                            </p>
                          </div>
                        )}

                        <hr />

                        <FormGroup row>
                          <FormControlLabel
                            control={
                              <Switch
                                color="primary"
                                checked={values.active}
                                onChange={() => {
                                  //form.setFieldValue("email", "wwooo");
                                  values.active = !values.active;
                                  this.forceUpdate();
                                }}
                                //onChange={handleChange}
                                //value="1"
                              />
                            }
                            label="Active (will show in app if active)"
                          />
                        </FormGroup>

                        <p>
                          <small>
                            If an agent has users tied to them, making them
                            inactive will no longer show them for their users
                            and they will be prompted to choose another agent.
                          </small>
                        </p>

                        <hr />

                        <p>
                          <button
                            class="btn btn-primary"
                            type="submit"
                            disabled={isSubmitting}
                          >
                            Update
                          </button>
                        </p>
                      </form>
                    )}
                  </Formik>
                </div>
              </div>
            </div>

            <div class="col-lg-6">
              <div class="card m-b-30">
                <div class="card-header">
                  <h5 class="m-b-0">Photo</h5>
                </div>
                <div class="card-body ">
                  <Dropzone
                    multiple={false}
                    accept={"image/jpeg, image/png"}
                    onDrop={acceptedFiles => {
                      const reader = new FileReader();

                      reader.onabort = () => alert("file reading was aborted");
                      reader.onerror = () => alert("file reading has failed");
                      reader.onload = () => {
                        // Do whatever you want with the file contents
                        const binaryStr = reader.result;

                        api.uploadAvatar(
                          item.id,
                          binaryStr,
                          response => {
                            //this.setState({ uploading: false, photo: response.photo });
                            //alert("ok! " + JSON.stringify(response));
                            this.loadProfile();
                            //saveUserData(response.user);
                          },
                          error => {
                            //this.setState({ uploading: false });
                            // alert("An error occurred");
                            window.showToastMessage(
                              "Error",
                              "An error occurred",
                              "danger",
                              "fe-x"
                            );
                          }
                        );
                      };

                      acceptedFiles.forEach(file =>
                        reader.readAsArrayBuffer(file)
                      );
                    }}
                  >
                    {({ getRootProps, getInputProps }) => (
                      <section>
                        <div {...getRootProps()}>
                          <input {...getInputProps()} />
                          {item.photo ? (
                            <div
                              style={{
                                border: "1px solid #ddd",
                                borderRadius: 5,
                                padding: 10,
                                cursor: "pointer",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center"
                              }}
                            >
                              <img
                                src={item.photo}
                                style={{
                                  width: 120,
                                  height: 120,
                                  borderRadius: 60
                                }}
                              />
                              <p style={{ marginTop: 10, color: "#aaa" }}>
                                Click to upload or drag new file.
                              </p>
                            </div>
                          ) : (
                            <div
                              style={{
                                border: "1px dotted #ddd",
                                borderRadius: 5,
                                height: 200,
                                padding: 10,
                                cursor: "pointer",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center"
                              }}
                            >
                              <p style={{ marginTop: 10, color: "#aaa" }}>
                                Drag &amp; drop a photo here, or click to
                                select.
                              </p>
                            </div>
                          )}
                        </div>
                      </section>
                    )}
                  </Dropzone>

                  {item.photo && (
                    <div>
                      <p style={{ marginTop: 10 }}>
                        <button
                          class="btn btn-danger"
                          onClick={e => {
                            if (
                              window.confirm(
                                "Are you sure you want to delete this photo?"
                              )
                            ) {
                              api.deleteAvatar(
                                item.id,
                                response => {
                                  //this.setState({ uploading: false, photo: response.photo });
                                  //alert("ok! " + JSON.stringify(response));
                                  this.loadProfile();
                                  //saveUserData(response.user);
                                },
                                error => {
                                  //this.setState({ uploading: false });
                                  window.showToastMessage(
                                    "Error",
                                    "An error occurred",
                                    "danger",
                                    "fe-x"
                                  );
                                }
                              );
                            }
                          }}
                        >
                          Remove photo
                        </button>
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  render() {
    return (
      <Inner>
        <div class="content">{this.agents()}</div>
      </Inner>
    );
  }
}

const styles = {};

export default Profile;
